import { Component, OnInit } from '@angular/core';
import {MenuController, ModalController} from "@ionic/angular";
import {Router} from "@angular/router";
import {ScrollDetail} from "@ionic/core";

@Component({
  selector: 'app-doctor-profile-detail-modal',
  templateUrl: './doctor-profile-detail-modal.component.html',
  styleUrls: ['./doctor-profile-detail-modal.component.scss'],
})
export class DoctorProfileDetailModalComponent implements OnInit {

  favorite_icon = false;
  tab: string = "about";
  showToolbar = false;
  Short: string = "1";

  constructor(private modalController: ModalController,private route: Router,private menu: MenuController) { }

  ngOnInit() {}
  dismiss(){
    this.modalController.dismiss();
  }
  ionViewWillEnter() {
    this.menu.enable(false);
  }
  ionViewWillLeave() {
    this.menu.enable(true);
  }





  onScroll($event: CustomEvent<ScrollDetail>) {
    if ($event && $event.detail && $event.detail.scrollTop) {
      const scrollTop = $event.detail.scrollTop;
      this.showToolbar = scrollTop >= 150;
    }
  }
  toggleSaveIcon1() {
    this.favorite_icon = !this.favorite_icon;
  }


  book_appointment_now() {
    this.route.navigate(['./appointmentbook']);
  }
  give_feedback() {
    this.route.navigate(['./addfeedback']);
  }



}
